// extracted by mini-css-extract-plugin
export default {"moduleWrapper":"FullWidthPicture_moduleWrapper__n2xnk","imageWrapper":"FullWidthPicture_imageWrapper__MpeHw"};